import { getRouteApi } from '@tanstack/react-router'
import { enqueueSnackbar } from 'notistack'

import { logSentry } from '@gto/sentry'
import { IconGtoWizardLogoSigned } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

import { buildOAuthRedirectUrl } from '@/utils/oauth'

const routeApi = getRouteApi('/login/oauth/')

// The loader either throws a redirect (success / already-processed code) or
// resolves with `{ status: 'error', message }` — this component only renders
// the error UI. No success branch.
export const OauthCallback = () => {
  const data = routeApi.useLoaderData()

  const handleRetry = () => {
    buildOAuthRedirectUrl(data.from)
      .then((url) => {
        window.location.href = url
      })
      .catch((e: unknown) => {
        logSentry('admin-web: OAuth retry build failed', e)
        enqueueSnackbar({ heading: 'Could not start sign-in', variant: 'error' })
      })
  }

  return (
    <div
      className="flex h-[100dvh] w-full items-center justify-center overflow-hidden p-6"
      data-tst="admin-login-oauth-error"
    >
      <div className="flex w-full max-w-[420px] flex-col gap-8 rounded-lg border border-divider bg-paper-elevation1 p-8 sm:p-6">
        <IconGtoWizardLogoSigned style={{ height: 24, width: 'auto' }} />

        <div className="flex flex-col gap-2">
          <Typography
            className="font-semibold"
            color="text.primary"
            variant="h5"
          >
            Sign-in failed
          </Typography>
          <Typography
            color="text.secondary"
            variant="body2"
          >
            {data.message.length > 0
              ? data.message
              : 'The sign-in was cancelled or returned no authorization code. Try again.'}
          </Typography>
        </div>

        <Button
          fullWidth
          color="primary"
          data-tst="admin-login-oauth-retry"
          variant="contained"
          onClick={handleRetry}
        >
          Try again
        </Button>
      </div>
    </div>
  )
}
